var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 4.6665L8.16683 1.1665H3.50016C3.19074 1.1665 2.894 1.28942 2.6752 1.50821C2.45641 1.72701 2.3335 2.02375 2.3335 2.33317V11.6665C2.3335 11.9759 2.45641 12.2727 2.6752 12.4915C2.894 12.7103 3.19074 12.8332 3.50016 12.8332H10.5002C10.8096 12.8332 11.1063 12.7103 11.3251 12.4915C11.5439 12.2727 11.6668 11.9759 11.6668 11.6665V4.6665ZM8.16683 1.1665V4.6665H11.6668M9.3335 7.58317H4.66683M9.3335 9.9165H4.66683M5.8335 5.24984H4.66683",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/file-text.dc51031e21cc05977a6e50bf603d327d.svg";
export { ForwardRef as ReactComponent };